import { Form, Container } from 'components/ui';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import i18n from '../../../../i18n'; // eslint-disable-line
import { useSelector } from 'react-redux';
import { VaxFormTitle } from 'components/impfschaeden/assistent/components/VaxFormTitle.js';
import useFormUpdate from 'components/impfschaeden/assistent/hooks/useFormUpdate.js';
import { BestaetigenForm } from 'VaxForm_12_Bestaetigen/components/BestaetigenForm.js';

const FormStyle = styled(Form)`
	width: '100%';
	align-items: 'center';
`;

const Step12 = (props) => {
	const [t] = useTranslation(['translation']);
	const vaxFormData = useSelector((state) => state.vaxFormData);
	const { update } = useFormUpdate();

	return (
		<>
			<form
				className={FormStyle}
				onSubmit={(e) => {
					e.preventDefault();
					props.next();
				}}
			>
				<Container spacing={4} style={{ maxWidth: '1074px' }}>
					<VaxFormTitle
						title={
							props.edit
								? t('impfschaeden.erfassen.verwie')
								: t('impfschaeden.erfassen.vielen_dank')
						}
						edit={props.edit}
					/>
					{/* <EntryCard {...vaxFormData} /> */}
					<BestaetigenForm
						update={update}
						formData={vaxFormData}
						loading={props.loading}
					/>
				</Container>
			</form>
		</>
	);
};

Step12.propTypes = {
	edit: PropTypes.bool,
	next: PropTypes.func,
	updateFormData: PropTypes.func,
	vaxFormData: PropTypes.object,
	loading: PropTypes.bool,
};

export default Step12;
